<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">
          Address
        </h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" @click.stop="saveInfo()" v-on="on">
              <v-icon class="mr-1">save</v-icon>
            </v-btn>
          </template>
          <span>Save house</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-form ref="detailsInfo" v-model="valid" lazy-validation>
      <v-layout row>
        <v-flex xs2>
          <v-text-field
            v-model="selectedHouse.unit"
            label="Unit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model="selectedHouse.num"
            label="Number"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model="selectedHouse.street"
            label="Street"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model="selectedHouse.suburb"
            label="Suburb"
            required
            flat
            :rules="textRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.city"
            label="City"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.country"
            label="Country"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <h2 class="headline py-3">Authorised Dates</h2>
      <v-layout row class="mb-4">
        <v-flex xs6 md4>
          <v-layout row>
            <v-flex align-self-center shrink>
              <v-icon large color="light-green lighten-1">calendar_today</v-icon>
            </v-flex>
            <v-flex grow>
              <v-menu
                v-model="rentalStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(selectedHouse.authorise_time)"
                    label="Authorised Start Date"
                    readonly
                    required
                    :rule="dateRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedHouse.authorise_time"
                  no-title
                  @input="rentalStartDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6 md4>
          <v-layout row>
            <v-flex align-self-center shrink>
              <v-icon large color="red lighten-2">calendar_today</v-icon>
            </v-flex>
            <v-flex grow>
              <v-menu
                v-model="rentalEndDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(selectedHouse.unauthorise_time)"
                    label="Authorised End Date"
                    readonly
                    required
                    :rule="dateRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedHouse.unauthorise_time"
                  no-title
                  @input="rentalEndDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <h2 class="headline py-3">Property Manager</h2>
      <v-layout row class="mb-4">
        <v-flex xs6 md4>
          <v-layout style="height: 40px;">
            <v-icon color="primary">face</v-icon>
            <v-select item-text="account" key="id" item-value="id"
              :items="propertyManagers"
              label="Choose an property manager"
              v-model="selectedHouse.pm_id"
              solo flat hide-details outlined
            ></v-select>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row class="mb-4">
        <v-flex xs6 md4>
          <v-layout style="height: 40px;">
            <v-checkbox primary color="warning" label="ARCHIVE THIS HOUSE" v-model="selectedHouse.archived"/>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'DetailsInfo',
  data() {
    return {
      textRules: [(v) => !!v || 'This field is required'],
      rentalStartDate: false,
      rentalEndDate: false,
      valid: true,
      dateRules: [
        (v) => !!v || 'This field is required',
        (v) =>
          /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}:$/.test(v) ||
          'Date must be valid',
      ],
    }
  },
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse',
      getTeams: 'User/getTeams'
    }),
    propertyManagers() {
      const team = this.getTeams('PropertyManager');
      //console.log('propertyManagers', {team})
      return team;
    },
  },
  methods: {
    ...mapActions({
      save: 'HouseList/updateHouse',
      fetchTeam: 'User/fetchTeam'
    }),
    fetchPropertyManagers() {
      this.fetchTeam({ role: 'PropertyManager'})
    },
    formatDate: function(date) {
      return date ? moment(date).format('DD MMMM YYYY') : null
    },
    saveInfo() {
      if (this.$refs.detailsInfo.validate()) {
        this.save(this.selectedHouse)
      }
    }
  },
  mounted() {
    if (!this.propertyManagers) {
      this.fetchPropertyManagers()
    }
  }
}
</script>
